export default "__VITE_ASSET__QX$CStiK__"